// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AnalysisWrapper__wrapper","cardHeader":"AnalysisWrapper__cardHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnalysisWrapper/AnalysisWrapper.scss
// module id = ./src/components/AnalysisWrapper/AnalysisWrapper.scss
// module chunks = 2